import React from "react"
import { handleImageError } from "helpers/image"
import { OrderLineInfoWrapper, OrderLineRow, ProductNameWrapper } from "../Shared.styled"
import { OrderLine } from "lib/types/generated/graphql-types"
import Money from "../../Money"
import DineroFactory from "dinero.js"

type Props = {
  orderLine: OrderLine | undefined
  orderQuantity: number
}

const OperationOrderLine = ({ orderLine, orderQuantity }: Props) => {
  return (
    <OrderLineRow>
      <OrderLineInfoWrapper>
        <img src={orderLine?.imageUrl ?? ""} onError={handleImageError} />
        <ProductNameWrapper>
          <b>{orderLine?.displayName}</b>
          <Money amount={orderLine?.distributedTotalPriceAmount ?? 0} currencyUnit={orderLine?.currencyCode as DineroFactory.Currency}/>
        </ProductNameWrapper>
      </OrderLineInfoWrapper>
      <b>{orderQuantity} / {orderLine?.quantity} </b>
    </OrderLineRow>
  )
}

export default OperationOrderLine
